export default __webpack_public_path__ + "static/media/toy-robotic-arm@2x.b3700ba6.png";